export default __webpack_public_path__ + "static/media/how_works.2e62c53c.mp4";